<template>
  <div v-if="question?.status !== 'READ_ONLY'">
    <div class="modal-input form-floating">
      <div
          :id="`waffle-counter-control_${question?.name}`"
          class="waffle-counter-control waffle-hover-border position-relative d-flex align-items-center"
          :class="{ 'waffle-invalid-color waffle-invalid-border': error && hasBeenInteractedWith }"
      >
        <div class="col-8">{{ question.prompt }}</div>
        <div class="col-4 d-flex align-items-center justify-content-end">
          <div class="ps-1 pe-1">
            <svg
                :id="`waffle-counter-icon-minus_${question.name}`"
                style="width:20px; height:20px;cursor:pointer"
                v-if="!Number(value || 0)"
                class="ms-4 waffle-counter-icon-minus z-n1"
                @click.prevent="$emit('user-interaction'); minus();"
                xmlns="http://www.w3.org/2000/svg" width="16" height="16"
                viewBox="0 0 16 16">
              <path id="minus"
                    d="M0,8a8,8,0,1,1,8,8A8,8,0,0,1,0,8ZM1,8A7,7,0,1,0,8,1,7,7,0,0,0,1,8Zm3.5.5a.5.5,0,0,1,0-1h7a.5.5,0,1,1,0,1Z"/>
            </svg>
            <svg
                :id="`waffle-counter-icon-minus_${question.name}`"
                style="width:20px; height:20px;cursor:pointer"
                v-else
                class="ms-4 waffle-counter-icon-minus z-n1"
                @click.prevent="$emit('user-interaction'); minus(); "
                xmlns="http://www.w3.org/2000/svg" width="16" height="16"
                viewBox="0 0 16 16">
              <path id="Path_25269" data-name="Path 25269" d="M8,16A8,8,0,1,0,0,8,8,8,0,0,0,8,16Z"/>
              <path id="Path_25271" data-name="Path 25271" d="M4,8a.5.5,0,0,1,.5-.5h7a.5.5,0,0,1,0,1h-7A.5.5,0,0,1,4,8Z"
                    fill="#fff"/>
            </svg>
          </div>

          <div id="value" class="fw-bolder user-select-none ms-4" style="width: 24px; text-align: center">{{
              value
            }}
          </div>
          <div class="ps-1 pe-1">
            <svg
                :id="`waffle-counter-icon-plus_${question.name}`"
                @click.prevent="$emit('user-interaction');add();"
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="20"
                fill="currentColor"
                class="waffle-counter-icon-plus ms-4"
                viewBox="0 0 16 16"
            >
              <path
                  d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z"
              />
            </svg>
          </div>

        </div>
      </div>
      <slot name="helptext" :isConfirm="!disableConfirm &&  (Number(question.value) && question?.prefilled) && !error" :isError="error"
            :confirmCb="() => {$emit('user-interaction');$emit('confirm'); }"></slot>
    </div>
  </div>
  <ReadOnly
      v-else
      :question="question"
      :value="value ? value:'-'"
      :forcePromptPlaceholder="forcePromptPlaceholder"
  />
</template>

<script>
import ReadOnly from "@/components/themeable-components/ReadOnly.vue";

export default {
  name: "Counter",
  components: {ReadOnly},
  emits: ["update:modelValue", "field-error", 'confirm','user-interaction'],
  props: ["question", "modelValue", "skipEagerValidation", 'disableConfirm','forcePromptPlaceholder','hasBeenInteractedWith','disabled'],
  data() {
    return {
      value: 0,
      error: "",
      shouldConfirm: false,
    };
  },
  mounted() {
    this.value = this.question.value || this.frontendCriteria?.min_value || 0;

    this.error = this.question.error;
    if (!this.skipEagerValidation) {
      this.validateInput()
    }
  },
  computed: {
    frontendCriteria() {
      if (this.question.criteria) {
        return this.question.criteria.find((el) => typeof el === "object");
      }
      return null;
    },
  },
  watch: {
    question(newQuestion) {
      if (newQuestion.value) {
        if(newQuestion.value !== this.value){
          this.$emit("update:modelValue", this.value);
        }
        this.value = newQuestion.value || 0
      }
      if (newQuestion.error) {
        this.error = newQuestion.error
        return this.$emit("field-error", true);
      }
    }
  },
  methods: {
    add() {

      if (this.frontendCriteria) {
        if (this.value < (this.frontendCriteria?.max_value || Number.MAX_SAFE_INTEGER)) {
          this.value++;
        }
      } else {
        this.value++;
      }
      this.validateInput();
    },
    minus() {
      if (this.frontendCriteria) {
        if (this.value > (this.frontendCriteria?.min_value || Number.MIN_SAFE_INTEGER)) {
          this.value--;
        }
      } else if (this.value > 0) {
        this.value--;
      }
      this.validateInput();
    },
    validateInput() {
      if (this.question.required && !this.value) {
        this.error = "Required";
        return this.$emit("field-error", true);
      } else if (this.question.value > this.frontendCriteria?.max_value) {
        this.error = `Value can't exceeds ${this.frontendCriteria?.max_value}`;
        return this.$emit("field-error", true);
      } else {
        this.$emit("field-error", false);
        this.error = "";
      }
      return this.$emit("update:modelValue", this.value);
    },
  },
};
</script>

